// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hoverContainer {
  position: relative;
  width: 215px;
  background: #1C2633;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}
.hoverContainer.withoutIssue {
  border: 3px solid #09AF91;
}
.hoverContainer.withIssue {
  border: 3px solid #FB4B4B;
}
.hoverContainer .hoverHeader {
  padding: 8px;
  text-align: center;
}
.hoverContainer .hoverHeader.withoutIssue {
  background: #09AF91;
}
.hoverContainer .hoverHeader.withIssue {
  background: #FB4B4B;
}
.hoverContainer .hoverHeader .headerText {
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: #FDFDFD;
  margin: 0 auto;
  width: fit-content;
}
.hoverContainer .hoverHeader .headerText .textView {
  padding-left: 3px;
}
.hoverContainer .hoverContent {
  flex: 1;
  padding: 8px 12px;
  color: #FDFDFD;
  padding-right: 4px;
  margin-right: 3px;
  overflow-x: hidden;
}
.hoverContainer .hoverContent .contentText {
  font-size: 20px;
  line-height: 24px;
  font-weight: 500;
}
.hoverContainer .hoverContent .contentText .hoverArrow {
  padding-left: 10px;
  padding-right: 10px;
}
.hoverContainer .hoverContent .passenger-parent {
  max-height: 150px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
  margin-top: 6px;
}
.hoverContainer .hoverContent .passenger-parent .multiplePassenger {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 4px 8px;
  background: #0D1117;
  border: 1px solid #1C2633;
  border-radius: 8px;
  margin-top: 6px;
}
.passengerBox {
  padding-top: 5px;
  padding-bottom: 5px;
}
.passengerBox .passengerContainer {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
}
.passengerBox .passengerContainer:first-child {
  padding-bottom: 2px;
}
.passengerBox .passengerContainer .passengerLabel {
  color: #708299;
}
.passengerBox .passengerContainer .passengerValue {
  color: #FDFDFD;
  padding-left: 10px;
}
.locationContainer {
  position: relative;
  width: 215px;
  background: #1C2633;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  border: 3px solid #2A3A4F;
  overflow-x: hidden;
}
.locationContainer.passengerClick {
  border: 3px solid #09AF91;
}
.locationContainer .locationHeader {
  padding: 8px;
  text-align: center;
  background: #2A3A4F;
}
.locationContainer .locationHeader.passengerClick {
  background: #09AF91;
}
.locationContainer .locationHeader .headerText {
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: #FDFDFD;
  margin: 0 auto;
  width: fit-content;
}
.locationContainer .locationHeader .headerText .textView {
  padding-left: 3px;
}
.locationContainer .locationContent {
  flex: 1;
  margin: 8px 12px;
  color: #FDFDFD;
  max-height: 150px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
  margin-right: 3px;
}
.locationContainer .locationContent .contentText {
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  text-align: center;
}
.locationContainer .locationContent .multiplePassenger {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 4px 8px;
  background: #0D1117;
  border: 1px solid #1C2633;
  border-radius: 8px;
  margin-top: 6px;
}
.detailContainer {
  position: relative;
  width: 405px;
  background: #1C2633;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}
.detailContainer.multiplePassenger {
  left: 5px;
}
.detailContainer.withoutIssue {
  border: 3px solid #09AF91;
}
.detailContainer.withIssue {
  border: 3px solid #FB4B4B;
}
.detailContainer .detailHeader {
  padding: 6px;
  text-align: center;
}
.detailContainer .detailHeader.withoutIssue {
  background: #09AF91;
}
.detailContainer .detailHeader.withIssue {
  background: #FB4B4B;
}
.detailContainer .detailHeader .headerText {
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: #FDFDFD;
  margin: 0 auto;
  width: fit-content;
}
.detailContainer .detailHeader .headerText .textView {
  padding-left: 3px;
}
.detailContainer .detailContent {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-right: 6px;
  margin-top: 6px;
}
.detailContainer .detailContent .content1 {
  padding: 8px;
  padding-top: 0px;
}
.detailContainer .detailContent .content1 .headerDetails {
  display: flex;
}
.detailContainer .detailContent .content1 .headerDetails .tripDetails {
  width: 25%;
  border-right: 1.5px solid #2A3A4F;
  padding: 5px 0px;
}
.detailContainer .detailContent .content1 .headerDetails .tripDetails .text {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #708299;
}
.detailContainer .detailContent .content1 .headerDetails .tripDetails .tripID {
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-decoration-line: underline;
  color: #386DFF;
}
.detailContainer .detailContent .content1 .headerDetails .passengerDeatils {
  width: 75%;
  display: flex;
  justify-content: flex-end;
  text-align: right;
}
.detailContainer .detailContent .content1 .description {
  padding: 10px 0px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
}
.detailContainer .detailContent .content1 .dashedLine {
  height: 1.5px;
  background: repeating-linear-gradient(to right, #2A3A4F, #2A3A4F 10px, transparent 4px, transparent 20px);
}
.detailContainer .detailContent .content1 .locationBox {
  display: flex;
}
.detailContainer .detailContent .content1 .locationBox .location {
  border-bottom: 1.5px solid #2A3A4F;
  padding: 16px 0px;
  width: 45%;
  display: flex;
}
.detailContainer .detailContent .content1 .locationBox .location .locationDetail {
  width: 85%;
}
.detailContainer .detailContent .content1 .locationBox .location .locationDetail .airportCode {
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: #FDFDFD;
}
.detailContainer .detailContent .content1 .locationBox .location .locationDetail .cityName {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #708299;
}
.detailContainer .detailContent .content1 .locationBox .location .lineHeader {
  width: 15%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.detailContainer .detailContent .content1 .locationBox .location .lineHeader .line {
  border: 1px solid #2A3A4F;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.detailContainer .detailContent .content1 .locationBox .arrow {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.detailContainer .detailContent .content1 .timeContainer {
  display: flex;
}
.detailContainer .detailContent .content1 .timeContainer .timeBox {
  width: 45%;
  display: flex;
}
.detailContainer .detailContent .content1 .timeContainer .timeBox .scheduleDetails {
  padding-top: 10px;
  width: 85%;
}
.detailContainer .detailContent .content1 .timeContainer .timeBox .scheduleDetails:first-child {
  border-right: 1.5px solid #2A3A4F;
  margin-right: 8px;
}
.detailContainer .detailContent .content1 .timeContainer .timeBox .scheduleDetails .scheduleText {
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
  color: #8998AB;
}
.detailContainer .detailContent .content1 .timeContainer .timeBox .scheduleDetails .scheduleTime {
  display: flex;
}
.detailContainer .detailContent .content1 .timeContainer .timeBox .scheduleDetails .scheduleTime .time {
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #FDFDFD;
}
.detailContainer .detailContent .content1 .timeContainer .timeBox .scheduleDetails .scheduleTime .timePeriod {
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #708299;
  padding-left: 6px;
}
.detailContainer .detailContent .content1 .timeContainer .arrow {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.detailContainer .detailContent .content2 {
  background: #121B26;
  border-radius: 32px 32px 0px 0px;
  padding: 10px;
  margin-top: 10px;
  margin-right: 6px;
}
.detailContainer .detailContent .content2 .flightContainer:last-child .dotIcon::after {
  display: none;
}
.detailContainer .detailContent .content2 .flightContainer.selected .flightContent .dotParent .dotIcon {
  background: #FFFFFF;
  border: 2px solid #386DFF;
}
.detailContainer .detailContent .content2 .flightContainer.selected .flightContent .dotParent .dotIcon::after {
  display: none;
}
.detailContainer .detailContent .content2 .flightContainer.selected .flightContent .flightList {
  border: 2px solid #386DFF;
}
.detailContainer .detailContent .content2 .flightContainer.cancelled .flightContent .flightList {
  border: 2px solid #D80909;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent {
  padding: 10px;
  display: flex;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .dotParent {
  display: flex;
  align-items: center;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .dotParent .dotIcon {
  background: #4B5F7A;
  border: 2px solid #384D69;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  position: relative;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .dotParent .dotIcon::after {
  content: "";
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  width: 1px;
  height: 117px;
  background-color: #2A3A4F;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .dotParent .mixedLine {
  height: 117px;
  position: relative;
  right: 7px;
  top: 50px;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .dotParent .mixedLine .mixedLineSolid {
  border: 1px solid #2A3A4F;
  height: 50%;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .dotParent .mixedLine .mixedLineDashed {
  height: 50%;
  background: repeating-linear-gradient(to bottom, #2A3A4F, #2A3A4F 5px, transparent 4px, transparent 10px);
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList {
  border: 1.5px solid #4B5F7A;
  border-radius: 6px;
  width: 337px;
  margin: 0px 8px;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightHeader {
  background: #1C2633;
  border-radius: 6px;
  display: flex;
  align-items: center;
  height: 30px;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightHeader .headerLeft {
  width: 50%;
  text-align: left;
  color: #FDFDFD;
  padding: 0px 8px;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightHeader .headerLeft .airlineId {
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightHeader .headerLeft .airlineTime {
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
  text-align: right;
  padding-left: 8px;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightHeader .headerRight {
  margin: 2px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 20px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightHeader .headerRight.success {
  color: #55FC7F;
  border: 1px solid #84FFA3;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightHeader .headerRight.fail {
  background-color: #D80909;
  border: 1px solid #D80909;
  color: #FDFDFD;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightLocation {
  display: flex;
  padding: 8px 0px;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightLocation .location {
  width: 33%;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightLocation .location .airportCode {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #A9BBC7;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightLocation .location .airportTime {
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: #FDFDFD;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightLocation .arrow {
  width: 33%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.detailContainer .detailContent .content2 .flightContainer .flightContent .flightList .flightLocation .arrow .arrowLine {
  width: 26px;
  height: 1px;
  border: 1px solid #4B5F7A;
  margin: 0px 6px;
}
.detailContainer .detailContent .content2 .flightContainer .connectionContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}
.detailContainer .detailContent .content2 .flightContainer .connectionContainer .connectText {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 24px;
  width: 235px;
  height: 28px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.detailContainer .detailContent .content2 .flightContainer .connectionContainer .connectText.normal {
  background: #1C2633;
  color: #A9BBC7;
}
.detailContainer .detailContent .content2 .flightContainer .connectionContainer .connectText.normal.location {
  border: 2px solid #386DFF;
}
.detailContainer .detailContent .content2 .flightContainer .connectionContainer .connectText.success {
  background: #FFB8B8;
  color: #384D69;
}
.textIcon {
  position: relative;
  left: 5px;
  top: 1px;
}
.textAlignRight {
  text-align: right;
}
.textAlignLeft {
  text-align: left;
}
.flightContainer.selected ~ .flightContainer .dotIcon {
  background: #FFFFFF !important;
  border: 2px solid #8998AB !important;
}
.cursor-pointer {
  cursor: pointer;
}
.passenger-selected {
  background-color: #2A3A4F !important;
}
.scrollContent::-webkit-scrollbar {
  width: 3px;
}
.scrollContent::-webkit-scrollbar-track {
  background: transparent;
}
.scrollContent::-webkit-scrollbar-thumb {
  background: #4B5F7A;
  border-radius: 4px;
}
.scrollContent::-webkit-scrollbar-thumb:hover {
  background: #3a4b60;
}
/* Apply same scrollbar styles to locationContent for airport popups */
.locationContent::-webkit-scrollbar,
.locationContent.scrollContent::-webkit-scrollbar {
  width: 3px !important;
}
.locationContent::-webkit-scrollbar-track,
.locationContent.scrollContent::-webkit-scrollbar-track {
  background: transparent !important;
}
.locationContent::-webkit-scrollbar-thumb,
.locationContent.scrollContent::-webkit-scrollbar-thumb {
  background: #4B5F7A !important;
  border-radius: 4px !important;
}
.locationContent::-webkit-scrollbar-thumb:hover,
.locationContent.scrollContent::-webkit-scrollbar-thumb:hover {
  background: #3a4b60 !important;
}
.passenger-card:first-child {
  margin-top: 0px !important;
}
.multi-passenger-wrapper {
  display: flex;
  align-items: center;
}
.multi-passenger-wrapper > * {
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/js/map/style/flight.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AACJ;AACI;EACI,yBAAA;AACR;AAEI;EACI,yBAAA;AAAR;AAdA;EAkBQ,YAAA;EACA,kBAAA;AADR;AAGQ;EACI,mBAAA;AADZ;AAIQ;EACI,mBAAA;AAFZ;AAxBA;EA8BY,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AAHZ;AAhCA;EAsCgB,iBAAA;AAHhB;AAnCA;EA4CQ,OAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AANR;AA3CA;EAoDY,eAAA;EACA,iBAAA;EACA,gBAAA;AANZ;AAhDA;EAyDgB,kBAAA;EACA,mBAAA;AANhB;AApDA;EA+DY,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AARZ;AA3DA;EAqEgB,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAPhB;AAaA;EACI,gBAAA;EACA,mBAAA;AAXJ;AASA;EAIQ,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AAVR;AAWQ;EACI,mBAAA;AATZ;AAAA;EAYY,cAAA;AATZ;AAHA;EAeY,cAAA;EACA,kBAAA;AATZ;AAcA;EACI,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AAZJ;AAcI;EACI,yBAAA;AAZR;AACA;EAeQ,YAAA;EACA,kBAAA;EACA,mBAAA;AAbR;AAeQ;EACI,mBAAA;AAbZ;AAPA;EAwBY,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AAdZ;AAfA;EAgCgB,iBAAA;AAdhB;AAlBA;EAsCQ,OAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAjBR;AA5BA;EAgDY,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAjBZ;AAlCA;EAuDY,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAlBZ;AAuBA;EACI,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AArBJ;AAuBI;EACI,SAAA;AArBR;AAwBI;EACE,yBAAA;AAtBN;AAyBI;EACE,yBAAA;AAvBN;AAKA;EAsBM,YAAA;EACA,kBAAA;AAxBN;AA0BM;EACE,mBAAA;AAxBR;AA2BM;EACE,mBAAA;AAzBR;AALA;EAkCQ,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AA1BR;AAbA;EA0CU,iBAAA;AA1BV;AAhBA;EAgDQ,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AA7BR;AAvBA;EAsDY,YAAA;EACA,gBAAA;AA5BZ;AA3BA;EA0DgB,aAAA;AA5BhB;AA9BA;EA6DoB,UAAA;EACA,iCAAA;EACA,gBAAA;AA5BpB;AAnCA;EAiEwB,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA3BxB;AAzCA;EAuEwB,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,cAAA;AA3BxB;AAlDA;EAkFoB,UAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;AA7BpB;AAxDA;EA0FgB,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA/BhB;AAlEA;EAqGgB,aAAA;EACA,yGAAA;AAhChB;AAtEA;EAgHgB,aAAA;AAvChB;AAzEA;EAkHoB,kCAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;AAtCpB;AA/EA;EAuHwB,UAAA;AArCxB;AAlFA;EAyH4B,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AApC5B;AAzFA;EAgI4B,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AApC5B;AAhGA;EAwIwB,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AArCxB;AAtGA;EA6I4B,yBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApC5B;AA7GA;EAsJoB,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAtCpB;AAnHA;EA8JgB,aAAA;AAxChB;AAtHA;EAgKoB,UAAA;EACA,aAAA;AAvCpB;AA1HA;EAmKwB,iBAAA;EACA,UAAA;AAtCxB;AAuCwB;EACI,iCAAA;EACA,iBAAA;AArC5B;AAlIA;EA0K4B,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AArC5B;AAxIA;EAgL4B,aAAA;AArC5B;AA3IA;EAkLgC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AApChC;AAjJA;EAwLgC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AApChC;AA3JA;EAqMoB,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvCpB;AAjKA;EA6MY,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;AAzCZ;AA2CgB;EAEQ,aAAA;AA1CxB;AA6CgB;EAIgB,mBAAA;EACA,yBAAA;AA9ChC;AA+CgC;EACI,aAAA;AA7CpC;AAsCgB;EAYY,yBAAA;AA/C5B;AAmDgB;EAGY,yBAAA;AAnD5B;AAxLA;EAgPoB,aAAA;EACA,aAAA;AArDpB;AA5LA;EAmPwB,aAAA;EACA,mBAAA;AApDxB;AAhMA;EAsP4B,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAnD5B;AAoD4B;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;AAlDhC;AAlNA;EAwQ4B,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AAnD5B;AAxNA;EA6QgC,yBAAA;EACA,WAAA;AAlDhC;AA5NA;EAiRgC,WAAA;EACA,yGAAA;AAlDhC;AAhOA;EAuRwB,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AApDxB;AAtOA;EA4R4B,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAnD5B;AA7OA;EAkSgC,UAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAlDhC;AAnPA;EAuSoC,gBAAA;EACA,eAAA;EACA,iBAAA;AAjDpC;AAxPA;EA4SoC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AAjDpC;AA/PA;EAoTgC,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAlDhC;AAmDgC;EACI,cAAA;EACA,yBAAA;AAjDpC;AAmDgC;EACI,yBAAA;EACA,yBAAA;EACA,cAAA;AAjDpC;AArRA;EA2U4B,aAAA;EACA,gBAAA;AAnD5B;AAzRA;EA8UgC,UAAA;AAlDhC;AA5RA;EAgVoC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjDpC;AAlSA;EAsVoC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjDpC;AAxSA;EA6VgC,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlDhC;AA9SA;EAkWoC,WAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;AAjDpC;AApTA;EA4WoB,aAAA;EACA,uBAAA;EACA,mBAAA;AArDpB;AAzTA;EAgXwB,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AApDxB;AAqDwB;EACI,mBAAA;EACA,cAAA;AAnD5B;AAoD4B;EACI,yBAAA;AAlDhC;AAqDwB;EACI,mBAAA;EACA,cAAA;AAnD5B;AA4DA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;AA1DJ;AA6DA;EACI,iBAAA;AA3DJ;AA8DA;EACI,gBAAA;AA5DJ;AA+DA;EACI,8BAAA;EACA,oCAAA;AA7DJ;AAgEA;EACI,eAAA;AA9DJ;AAiEA;EACI,oCAAA;AA/DJ;AAkEA;EACI,UAAA;AAhEJ;AAmEA;EACI,uBAAA;AAjEJ;AAoEA;EACI,mBAAA;EACA,kBAAA;AAlEJ;AAqEA;EACI,mBAAA;AAnEJ;AACA,sEAAsE;AAsEtE;;EAEI,qBAAA;AApEJ;AAuEA;;EAEI,kCAAA;AArEJ;AAwEA;;EAEI,8BAAA;EACA,6BAAA;AAtEJ;AAyEA;;EAEI,8BAAA;AAvEJ;AA0EA;EACI,0BAAA;AAxEJ;AA2EA;EACI,aAAA;EACA,mBAAA;AAzEJ;AA4EA;EACI,cAAA;AA1EJ","sourcesContent":[".hoverContainer {\n    position: relative;\n    width: 215px;\n    background: #1C2633;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    overflow-x: hidden;\n  \n    &.withoutIssue {\n        border: 3px solid #09AF91;\n    }\n\n    &.withIssue {\n        border: 3px solid #FB4B4B;\n    }\n\n    .hoverHeader {\n        padding: 8px;\n        text-align: center;\n    \n        &.withoutIssue {\n            background: #09AF91;\n        }\n\n        &.withIssue {\n            background: #FB4B4B;\n        }\n\n        .headerText {\n            font-weight: 700;\n            font-size: 12px;\n            line-height: 16px;\n            color: #FDFDFD;\n            margin: 0 auto;\n            width: fit-content;\n\n            .textView {\n                padding-left: 3px;\n            }\n        }\n    }\n  \n    .hoverContent {\n        flex: 1;\n        padding: 8px 12px;\n        color: #FDFDFD;\n        padding-right: 4px;\n        margin-right: 3px;\n        overflow-x: hidden;\n    \n        .contentText {\n            font-size: 20px;\n            line-height: 24px;\n            font-weight: 500;\n\n            .hoverArrow {\n                padding-left: 10px;\n                padding-right: 10px;\n            }\n        }\n\n        .passenger-parent {\n            max-height: 150px;\n            overflow-y: auto;\n            overflow-x: hidden;\n            padding-right: 4px;\n            margin-top: 6px;\n            .multiplePassenger {\n                display: flex;\n                flex-direction: column;\n                align-items: flex-start;\n                padding: 4px 8px;\n                background: #0D1117;\n                border: 1px solid #1C2633;\n                border-radius: 8px;\n                margin-top: 6px;\n            }\n        }\n    }\n}\n  \n.passengerBox {\n    padding-top: 5px;\n    padding-bottom: 5px;\n    .passengerContainer {\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 16px;\n        display: flex;\n        &:first-child {\n            padding-bottom: 2px;\n        }\n        .passengerLabel {\n            color: #708299;\n        }\n        .passengerValue {\n            color: #FDFDFD;\n            padding-left: 10px;\n        }\n    }\n}\n\n.locationContainer {\n    position: relative;\n    width: 215px;\n    background: #1C2633;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    border: 3px solid #2A3A4F;\n    overflow-x: hidden;\n\n    &.passengerClick {\n        border: 3px solid #09AF91;\n    }\n\n    .locationHeader {\n        padding: 8px;\n        text-align: center;\n        background: #2A3A4F;\n\n        &.passengerClick {\n            background: #09AF91;\n        }\n\n        .headerText {\n            font-weight: 700;\n            font-size: 12px;\n            line-height: 16px;\n            color: #FDFDFD;\n            margin: 0 auto;\n            width: fit-content;\n\n            .textView {\n                padding-left: 3px;\n            }\n        }\n    }\n  \n    .locationContent {\n        flex: 1;\n        margin: 8px 12px;\n        color: #FDFDFD;\n        max-height: 150px;\n        overflow-y: auto;\n        overflow-x: hidden;\n        padding-right: 4px;\n        margin-right: 3px;\n    \n        .contentText {\n            font-size: 12px;\n            line-height: 16px;\n            font-weight: 500;\n            text-align: center;\n        }\n\n        .multiplePassenger {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            padding: 4px 8px;\n            background: #0D1117;\n            border: 1px solid #1C2633;\n            border-radius: 8px;\n            margin-top: 6px;\n        }\n    }\n}\n\n.detailContainer {\n    position: relative;\n    width: 405px;\n    background: #1C2633;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    overflow-x: hidden;\n  \n    &.multiplePassenger {\n        left: 5px;\n    }\n\n    &.withoutIssue {\n      border: 3px solid #09AF91;\n    }\n  \n    &.withIssue {\n      border: 3px solid #FB4B4B;\n    }\n  \n    .detailHeader {\n      padding: 6px;\n      text-align: center;\n  \n      &.withoutIssue {\n        background: #09AF91;\n      }\n  \n      &.withIssue {\n        background: #FB4B4B;\n      }\n  \n      .headerText {\n        font-weight: 700;\n        font-size: 12px;\n        line-height: 16px;\n        color: #FDFDFD;\n        margin: 0 auto;\n        width: fit-content;\n  \n        .textView {\n          padding-left: 3px;\n        }\n      }\n    }\n  \n    .detailContent {\n        max-height: 400px;\n        overflow-y: auto;\n        overflow-x: hidden;\n        margin-right: 6px;\n        margin-top: 6px;\n        .content1 {\n            padding: 8px;\n            padding-top: 0px;\n    \n            .headerDetails {\n                display: flex;\n    \n                .tripDetails {\n                    width: 25%;\n                    border-right: 1.5px solid #2A3A4F;\n                    padding: 5px 0px;\n                    .text {\n                        font-weight: 500;\n                        font-size: 12px;\n                        line-height: 16px;\n                        color: #708299;\n                    }\n                    .tripID {\n                        font-weight: 500;\n                        font-size: 14px;\n                        line-height: 18px;\n                        display: flex;\n                        align-items: center;\n                        text-decoration-line: underline;\n                        color: #386DFF;\n                    }\n                }\n        \n                .passengerDeatils {\n                    width: 75%;\n                    display: flex;\n                    justify-content: flex-end;\n                    text-align: right;\n                }\n            }\n    \n            .description {\n                padding: 10px 0px;\n                color: white;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                font-weight: 500;\n                font-size: 12px;\n                line-height: 16px;\n            }\n\n            .dashedLine {\n                height: 1.5px;\n                background: repeating-linear-gradient(\n                    to right,\n                    #2A3A4F,\n                    #2A3A4F 10px,\n                    transparent 4px,\n                    transparent 20px\n                );\n            }\n\n            .locationBox {\n                display: flex;\n                .location {\n                    border-bottom: 1.5px solid #2A3A4F;\n                    padding: 16px 0px;\n                    width: 45%;\n                    display: flex;\n                    .locationDetail {\n                        width: 85%;\n                        .airportCode {\n                            font-weight: 500;\n                            font-size: 20px;\n                            line-height: 24px;\n                            text-align: center;\n                            color: #FDFDFD;\n                        }\n                        .cityName {\n                            font-weight: 500;\n                            font-size: 12px;\n                            line-height: 16px;\n                            text-align: center;\n                            color: #708299;\n                        }\n                    }\n                    .lineHeader {\n                        width: 15%;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        .line {\n                            border: 1px solid #2A3A4F;\n                            width: 100%;\n                            display: flex;\n                            align-items: center;\n                            justify-content: center;\n                        }\n                    }\n                }\n                .arrow {\n                    width: 10%;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                }\n            }\n\n            .timeContainer {\n                display: flex;\n                .timeBox {\n                    width: 45%;\n                    display: flex;\n                    .scheduleDetails {\n                        padding-top: 10px;\n                        width: 85%;\n                        &:first-child {\n                            border-right: 1.5px solid #2A3A4F;\n                            margin-right: 8px;\n                        }\n                        .scheduleText {\n                            font-weight: 500;\n                            font-size: 10px;\n                            line-height: 14px;\n                            color: #8998AB;\n                        }\n                        .scheduleTime {\n                            display: flex;\n                            .time {\n                                font-weight: 500;\n                                font-size: 18px;\n                                line-height: 22px;\n                                color: #FDFDFD;\n                            }\n                            .timePeriod {\n                                font-weight: 500;\n                                font-size: 10px;\n                                line-height: 14px;\n                                display: flex;\n                                align-items: center;\n                                text-align: center;\n                                color: #708299;\n                                padding-left: 6px;\n                            }\n                        }\n                    }\n                }\n                .arrow {\n                    width: 10%;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                }\n            }\n        }\n        .content2 {\n            background: #121B26;\n            border-radius: 32px 32px 0px 0px;\n            padding: 10px;\n            margin-top: 10px;\n            margin-right: 6px;\n            .flightContainer {\n                &:last-child {\n                    .dotIcon::after {\n                        display: none;\n                    }\n                }\n                &.selected {\n                    .flightContent {\n                        .dotParent {\n                            .dotIcon {\n                                background: #FFFFFF;\n                                border: 2px solid #386DFF;\n                                &::after {\n                                    display: none;\n                                }\n                            }\n                        }\n                        .flightList {\n                            border: 2px solid #386DFF;\n                        }\n                    }\n                }\n                &.cancelled {\n                    .flightContent {\n                        .flightList {\n                            border: 2px solid #D80909;\n                        }\n                    }\n                }\n                .flightContent {\n                    padding: 10px;\n                    display: flex;\n                    .dotParent {\n                        display: flex;\n                        align-items: center;\n                        .dotIcon {\n                            background: #4B5F7A;\n                            border: 2px solid #384D69;\n                            width: 13px;\n                            height: 13px;\n                            border-radius: 50%;\n                            position: relative;\n                            &::after {\n                                content: \"\";\n                                position: absolute;\n                                top: 12px;\n                                left: 50%;\n                                transform: translateX(-50%);\n                                width: 1px;\n                                height: 117px;\n                                background-color: #2A3A4F;\n                            }\n                        }\n                        .mixedLine {\n                            height: 117px;\n                            position: relative;\n                            right: 7px;\n                            top: 50px;\n                            .mixedLineSolid {\n                                border: 1px solid #2A3A4F;\n                                height: 50%;\n                            }\n                            .mixedLineDashed {\n                                height: 50%;\n                                background: repeating-linear-gradient(to bottom, #2A3A4F, #2A3A4F 5px, transparent 4px, transparent 10px);\n                            }\n                        }\n                    }\n                    .flightList {\n                        border: 1.5px solid #4B5F7A;\n                        border-radius: 6px;\n                        width: 337px;\n                        margin: 0px 8px;\n                        .flightHeader {\n                            background: #1C2633;\n                            border-radius: 6px;\n                            display: flex;\n                            align-items: center;\n                            height: 30px;\n                            .headerLeft {\n                                width: 50%;\n                                text-align: left;\n                                color: #FDFDFD;\n                                padding: 0px 8px;\n                                .airlineId {\n                                    font-weight: 700;\n                                    font-size: 12px;\n                                    line-height: 16px;\n                                }\n                                .airlineTime {\n                                    font-weight: 500;\n                                    font-size: 10px;\n                                    line-height: 14px;\n                                    text-align: right;\n                                    padding-left: 8px;\n                                }\n                            }\n                            .headerRight {\n                                margin: 2px 8px;\n                                display: flex;\n                                justify-content: center;\n                                align-items: center;\n                                width: 50%;\n                                height: 20px;\n                                border-radius: 12px;\n                                font-weight: 700;\n                                font-size: 10px;\n                                line-height: 12px;\n                                text-transform: uppercase;\n                                &.success {\n                                    color: #55FC7F;\n                                    border: 1px solid #84FFA3;\n                                }\n                                &.fail {\n                                    background-color: #D80909;\n                                    border: 1px solid #D80909;\n                                    color: #FDFDFD;\n                                }\n                            }\n                        }\n                        .flightLocation {\n                            display: flex;\n                            padding: 8px 0px;\n                            .location {\n                                width: 33%;\n                                .airportCode {\n                                    font-weight: 500;\n                                    font-size: 12px;\n                                    line-height: 16px;\n                                    color: #A9BBC7;\n                                }\n                                .airportTime {\n                                    font-weight: 700;\n                                    font-size: 12px;\n                                    line-height: 16px;\n                                    color: #FDFDFD;\n                                }\n                            }\n                            .arrow {\n                                width: 33%;\n                                display: flex;\n                                align-items: center;\n                                justify-content: center;\n                                .arrowLine {\n                                    width: 26px;\n                                    height: 1px;\n                                    border: 1px solid #4B5F7A;\n                                    margin: 0px 6px;\n                                }\n                            }\n                        }\n                    }\n                }\n                .connectionContainer {\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    .connectText {\n                        display: flex;\n                        justify-content: center;\n                        align-items: center;\n                        padding: 8px 24px;\n                        width: 235px;\n                        height: 28px;\n                        border-radius: 4px;\n                        font-weight: 500;\n                        font-size: 12px;\n                        line-height: 16px;\n                        text-align: center;\n                        &.normal {\n                            background: #1C2633;\n                            color: #A9BBC7;\n                            &.location {\n                                border: 2px solid #386DFF;\n                            }\n                        }\n                        &.success {\n                            background: #FFB8B8;\n                            color: #384D69;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.textIcon {\n    position: relative;\n    left: 5px;\n    top: 1px;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n.textAlignLeft {\n    text-align: left;\n}\n  \n.flightContainer.selected ~ .flightContainer .dotIcon {\n    background: #FFFFFF !important;\n    border: 2px solid #8998AB !important;\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}\n\n.passenger-selected {\n    background-color: #2A3A4F !important;\n}\n\n.scrollContent::-webkit-scrollbar {\n    width: 3px;\n}\n\n.scrollContent::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.scrollContent::-webkit-scrollbar-thumb {\n    background: #4B5F7A;\n    border-radius: 4px;\n}\n\n.scrollContent::-webkit-scrollbar-thumb:hover {\n    background: #3a4b60;\n}\n\n/* Apply same scrollbar styles to locationContent for airport popups */\n.locationContent::-webkit-scrollbar,\n.locationContent.scrollContent::-webkit-scrollbar {\n    width: 3px !important;\n}\n\n.locationContent::-webkit-scrollbar-track,\n.locationContent.scrollContent::-webkit-scrollbar-track {\n    background: transparent !important;\n}\n\n.locationContent::-webkit-scrollbar-thumb,\n.locationContent.scrollContent::-webkit-scrollbar-thumb {\n    background: #4B5F7A !important;\n    border-radius: 4px !important;\n}\n\n.locationContent::-webkit-scrollbar-thumb:hover,\n.locationContent.scrollContent::-webkit-scrollbar-thumb:hover {\n    background: #3a4b60 !important;\n}\n\n.passenger-card:first-child {\n    margin-top: 0px !important;\n}\n\n.multi-passenger-wrapper {\n    display: flex;\n    align-items: center;\n}\n\n.multi-passenger-wrapper > * {\n    flex-shrink: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
